import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;

// import ExpandHas from "./expandHas";
import ExpandNone from "./expandNone";
import H5 from "./h5";
import cx from "classnames";
import styles from "./index.module.less";
import stylesProducts from "@/components/Pages/Finance/Styles/products.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";

export default observer(({ data, rowCls }) => {
  const t = useTranslation();
  const { app, finance } = useStore();

  //是否有展开
  // const hasExpand = useMemo(() => {
  //   console.log(data);
  //   return data.productCollections.length > 1;
  // }, [data]);

  // if (hasExpand)
  //   return <ExpandHas data={data} rowCls={rowCls}/>
  // else
  // return <ExpandNone data={data} rowCls={rowCls} />;

  const groupObj = {
    groupTag: data.groupTag,
    productCollections: [data],
  };

  if (app.isH5) return <H5 data={groupObj} rowCls={rowCls} />;

  // return data.productCollections.map((category, index) => <ExpandNone key={index} data={category} rowCls={rowCls} />);

  return <ExpandNone data={data} rowCls={rowCls} />;
});
